import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
declare let fbq: Function;

@Injectable({
  providedIn: 'root',
})
export class FacebookPixelService {
  private isProductionSite =
    window.location.origin === 'https://cleverdeals.net';

  trackCompleteRegistration() {
    if (this.isProductionSite) {
      fbq('track', 'CompleteRegistration');
    }
  }

  trackInitiateCheckout(totalAmount) {
    if (this.isProductionSite) {
      const fbc = localStorage.getItem('fbc'); // ✅ Get the stored fbc value

      fbq('track', 'InitiateCheckout', {
        value: totalAmount,
        currency: 'GBP'
      }, { fbc });

    }
  }



  trackPurchase(value: number, currency: string = environment.paymentCurrency) {
    if (this.isProductionSite) {
      fbq('track', 'Purchase', {
        value,
        currency,
      });
    }
  }

  /** ✅ Track when an item is added to the cart with maximum details */
  trackAddToCart(
    amount?: number,                         // Price of the item
    currency: string = environment.paymentCurrency,
    options: {
      id?: string;                            // Product/Deal ID
      name?: string;                           // Product/Deal name
      category?: string;                       // Product category
      quantity?: number;                       // Quantity added
      brand?: string;                           // Optional brand
      contentType?: 'product' | 'deal' | string;// Content type
    } = {}
  ) {
    if (!this.isProductionSite) return;

    const params: Record<string, any> = {
      ...(amount != null ? { value: amount, currency } : {}),
      ...(options.id ? { content_ids: [options.id] } : {}),
      ...(options.name ? { content_name: options.name } : {}),
      ...(options.category ? { content_category: options.category } : {}),
      ...(options.quantity ? { num_items: options.quantity } : {}),
      ...(options.brand ? { brand: options.brand } : {}),
      content_type: options.contentType || 'product',
    };


    fbq('track', 'AddToCart', params);
  }

}
